export default __webpack_public_path__ + "static/media/Inukshuk.0a8c4cf9.jpg";